(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-product-row"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-art-step]');
  if(!button)return;
  const track=document.getElementById(button.getAttribute('aria-controls'));
  if(!track)return;
  const first=track.firstElementChild;
  const gap=parseFloat(getComputedStyle(track).columnGap)||0;
  const step=first.getBoundingClientRect().width+gap;
  track.scrollBy({left:Number(button.dataset.artStep)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-special-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-special-step]');
  if(!button)return;
  const track=document.getElementById(button.getAttribute('aria-controls'));
  const first=track?.firstElementChild;
  if(!first)return;
  const step=first.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);
  track.scrollBy({left:Number(button.dataset.specialStep)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('pointerdown', event => {
  const stage = event.target.closest('.fendooy-comparison-stage');
  const link = stage?.querySelector('.fendooy-comparison-link');
  if (!link) return;
  document._fendooyComparisonPointer = { stage, x: event.clientX, y: event.clientY, moved: false };
});

document.addEventListener('pointermove', event => {
  const state = document._fendooyComparisonPointer;
  if (!state || state.moved) return;
  if (Math.hypot(event.clientX - state.x, event.clientY - state.y) > 8) state.moved = true;
});

document.addEventListener('click', event => {
  const stage = event.target.closest('.fendooy-comparison-stage');
  const link = stage?.querySelector('.fendooy-comparison-link');
  if (!link) return;
  const state = document._fendooyComparisonPointer;
  const moved = state?.stage === stage && state.moved;
  delete document._fendooyComparisonPointer;
  if (moved || event.target.closest('.comparison__button')) {
    event.preventDefault();
    return;
  }
  window.location.assign(link.href);
}, true);

  } catch(e) { console.error(e); }
})();
})();
